// extracted by mini-css-extract-plugin
export var heroImage = "contacto-module--heroImage--QdWPQ";
export var formRow = "contacto-module--form-row--egwoV";
export var formRight = "contacto-module--form-right--XIJyc";
export var info = "contacto-module--info--TKUNs";
export var card = "contacto-module--card--SplER";
export var headlineContainer = "contacto-module--headline-container--mvsNH";
export var headerContent = "contacto-module--headerContent--WuNk0";